// Notificações, confirmações e loading via SweetAlert2 (plugin incluído no AdminLTE 3,
// com o tema @sweetalert2/theme-bootstrap-4 e os estilos de dark-mode do próprio AdminLTE)
const swal = () => window.Swal;

const Toast = () => swal()?.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 4000,
  timerProgressBar: true,
  didOpen: (el) => {
    el.addEventListener("mouseenter", swal().stopTimer);
    el.addEventListener("mouseleave", swal().resumeTimer);
  },
});

const fire = (icon, title) => Toast()?.fire({ icon, title });

export const toast = (msg) => fire("info", msg);
toast.success = (msg) => fire("success", msg);
toast.error = (msg) => fire("error", msg);
toast.warning = (msg) => fire("warning", msg);

// Confirmação (substitui window.confirm); resolve true/false
export const confirmDialog = async ({ title, text, confirmText = "Confirmar", danger = false }) => {
  if (!swal()) return window.confirm(text || title);
  const r = await swal().fire({
    title,
    text,
    icon: danger ? "warning" : "question",
    showCancelButton: true,
    confirmButtonText: confirmText,
    cancelButtonText: "Cancelar",
    reverseButtons: true,
    focusCancel: danger,
    customClass: { confirmButton: `btn ${danger ? "btn-danger" : "btn-primary"} ml-2`, cancelButton: "btn btn-default" },
    buttonsStyling: false,
  });
  return r.isConfirmed;
};

// Loading de ações: só aparece se a ação demorar mais que DELAY_MS (evita "piscar" em respostas rápidas)
const DELAY_MS = 300;
let pending = 0;
let timer = null;
let shown = false;

const show = () => {
  shown = true;
  swal()?.fire({
    title: "Processando...",
    allowOutsideClick: false,
    allowEscapeKey: false,
    showConfirmButton: false,
    didOpen: () => swal().showLoading(),
  });
};

export const withLoading = async (fn) => {
  if (pending++ === 0) timer = setTimeout(show, DELAY_MS);
  try {
    return await fn();
  } finally {
    if (--pending === 0) {
      clearTimeout(timer);
      if (shown && swal()?.isLoading()) swal().close();
      shown = false;
    }
  }
};
